import { Col, Placeholder, Stack } from 'react-bootstrap';

export const PostedJobSkeleton = () => {
	return (
		<>
			<Col md={6}>
				<Stack className="posted-job-box h-auto">
					<div className="posted-job-box-content d-flex align-items-center gap-3 position-relative">
						<div className="d-flex flex-column flex-md-row align-items-md-center flex-1 gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
					</div>
					<div className="posted-job-box-description">
						<Placeholder animation="glow">
							<Placeholder xs={12} />
							<Placeholder xs={12} />
						</Placeholder>
					</div>
					<div className="posted-job-box-basic-info">
						<Placeholder animation="glow">
							<Placeholder xs={2} /> <Placeholder xs={3} /> <Placeholder xs={1} />{' '}
							<Placeholder xs={4} /> <Placeholder xs={3} /> <Placeholder xs={4} />
						</Placeholder>
					</div>
					<div className="posted-job-box-actions d-flex gap-2 gap-sm-3 justify-content-sm-end mt-auto">
						<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
						<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
					</div>
				</Stack>
			</Col>
			<Col md={6}>
				<Stack className="posted-job-box h-auto">
					<div className="posted-job-box-content d-flex align-items-center gap-3 position-relative">
						<div className="d-flex flex-column flex-md-row align-items-md-center flex-1 gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
					</div>
					<div className="posted-job-box-description">
						<Placeholder animation="glow">
							<Placeholder xs={12} />
							<Placeholder xs={12} />
						</Placeholder>
					</div>
					<div className="posted-job-box-basic-info">
						<Placeholder animation="glow">
							<Placeholder xs={2} /> <Placeholder xs={3} /> <Placeholder xs={1} />{' '}
							<Placeholder xs={4} /> <Placeholder xs={3} /> <Placeholder xs={4} />
						</Placeholder>
					</div>
					<div className="posted-job-box-actions d-flex gap-2 gap-sm-3 justify-content-sm-end mt-auto">
						<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
						<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
					</div>
				</Stack>
			</Col>

			<Col md={6}>
				<Stack className="posted-job-box h-auto">
					<div className="posted-job-box-content d-flex align-items-center gap-3 position-relative">
						<div className="d-flex flex-column flex-md-row align-items-md-center flex-1 gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
					</div>
					<div className="posted-job-box-description">
						<Placeholder animation="glow">
							<Placeholder xs={12} />
							<Placeholder xs={12} />
						</Placeholder>
					</div>
					<div className="posted-job-box-basic-info">
						<Placeholder animation="glow">
							<Placeholder xs={2} /> <Placeholder xs={3} /> <Placeholder xs={1} />{' '}
							<Placeholder xs={4} /> <Placeholder xs={3} /> <Placeholder xs={4} />
						</Placeholder>
					</div>
					<div className="posted-job-box-actions d-flex gap-2 gap-sm-3 justify-content-sm-end mt-auto">
						<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
						<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
					</div>
				</Stack>
			</Col>

			<Col md={6}>
				<Stack className="posted-job-box h-auto">
					<div className="posted-job-box-content d-flex align-items-center gap-3 position-relative">
						<div className="d-flex flex-column flex-md-row align-items-md-center flex-1 gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
					</div>
					<div className="posted-job-box-description">
						<Placeholder animation="glow">
							<Placeholder xs={12} />
							<Placeholder xs={12} />
						</Placeholder>
					</div>
					<div className="posted-job-box-basic-info">
						<Placeholder animation="glow">
							<Placeholder xs={2} /> <Placeholder xs={3} /> <Placeholder xs={1} />{' '}
							<Placeholder xs={4} /> <Placeholder xs={3} /> <Placeholder xs={4} />
						</Placeholder>
					</div>
					<div className="posted-job-box-actions d-flex gap-2 gap-sm-3 justify-content-sm-end mt-auto">
						<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
						<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
					</div>
				</Stack>
			</Col>
		</>
	);
};

export default PostedJobSkeleton;
